import React, { useState, useEffect } from 'react';
import CheckoutService from '../services/CheckoutService';
import { redirect } from 'react-router-dom';
import request from '../shared/http';
import { Alert, Snackbar } from '@mui/material';

const COUNTRY_OPTIONS = [
    { code: 'IN', name: 'India' },
];
const TYPE = {
  RAZORPAY: 'razorpay',
  INSTAMOJO: 'instamojo',
  CCAVENUE: 'ccavenue',
  ORKAPAY: 'orkapay',
  UPI: 'upi'
};
const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
  'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
  'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
  'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
  'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Delhi', 'Jammu and Kashmir',
  'Ladakh', 'Puducherry', 'Chandigarh', 'Andaman and Nicobar Islands',
  'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep'
];

function CheckoutView() {
    const queryParams = new URLSearchParams(window.location.search);
    const getEffectiveEstoreStoreId = () => {
        const qp = new URLSearchParams(window.location.search);
        return qp.get('store_id')
            || (qp.get('commerce_platform') === 'estore' ? qp.get('commerce_store_ref') : null);
    };
    const [address, setAddress] = useState({
        firstname: '',
        email: '',
        mobile: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        pincode: ''
    });

    const [errors, setErrors] = useState({});
    const [products, setProducts] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');
    const [settings, setSettings] = useState(null);
    const [paymentOption, setPaymentOption] = useState("");
    const [order, setOrder] = useState(null);
    const [phonenumber, setPhoneNumber] = useState(null);
    const [serviceId, setServiceId] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isPartial, setIsPartial] = useState(false);
    const [checkoutDetails, setCheckoutDetails] = useState({
    items: [],
    delivery_charge: 0,
    total_amount: 0,
    currency: "₹",
    subtotal: 0,
    tax: 0,
    is_partial: false,
    partial_amount: 0,
    future_amount: 0,
    package_fee: 0,
    store_discount_amount: 0,
    coupon_amount: 0,
    is_free_delivery: true,
    all_tax: 0
})
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
      });
    const [couponCode, setCouponCode] = useState("");
    const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
    const [stateDebounceTimeout, setStateDebounceTimeout] = useState(null);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const [verticalCheckout, setVerticalCheckout] = useState(null);
    const [verticalLoading, setVerticalLoading] = useState(false);
    const [verticalCustomer, setVerticalCustomer] = useState({
        name: '',
        mobile: '',
        address: '',
    });
    const [verticalSuccess, setVerticalSuccess] = useState(false);

    useEffect(() => {
    const qp = new URLSearchParams(window.location.search);
    const verticalParam = qp.get('vertical');
    const checkoutSessionId = qp.get('checkout_session_id');
    const serviceIdParam = qp.get('service_id');
    if (verticalParam && checkoutSessionId && serviceIdParam) {
        setServiceId(serviceIdParam);
        setVerticalLoading(true);
        CheckoutService.getVerticalCheckoutDetails(serviceIdParam, checkoutSessionId)
            .then((data) => setVerticalCheckout(data))
            .catch(() => {
                setSnackbar({
                    open: true,
                    message: 'Unable to load booking checkout.',
                    severity: 'error',
                });
            })
            .finally(() => setVerticalLoading(false));
        return;
    }
    const storeIdParam = qp.get('store_id');
    const productIdsParam = qp.get('product_ids');
    const phoneNumber = qp.get('phone_number');
    const commercePlat = qp.get('commerce_platform');
    const commerceRef = qp.get('commerce_store_ref');
    setServiceId(serviceIdParam);
    setPhoneNumber(phoneNumber);
    let variantQuantityMap = {};
    let variantIds = [];
    if (productIdsParam) {
        const entries = productIdsParam.split(',');
        entries.forEach(entry => {
            const [variantId, qty] = entry.split(':');
            if (variantId) {
                variantIds.push(variantId);
                variantQuantityMap[variantId] = parseInt(qty || '1', 10);
            }
        });
    }

    const loadEstoreCart = (sid) => {
        CheckoutService.getCartItems(sid, variantIds)
            .then(data => {
                const enriched = data.products.map(product => ({
                    ...product,
                    quantity: variantQuantityMap[product.variantId] || 1
                }));
                setProducts(enriched);
                setSettings(data.settings);
                if (data.settings) {
                    if (data.settings.whatsapp_checkout) setPaymentOption("whatsapp");
                    else if (data.settings.cod_enabled) setPaymentOption("offline");
                    else if (data.settings.razorpay_key_id) setPaymentOption("online");
                    else if (data.settings.partial_amount || data.settings.partial_percent) setPaymentOption("partialPayment");
                }
            })
            .catch(() => setProducts([]));
    };

    if (commercePlat === 'woocommerce') {
        setProducts([]);
        return;
    }

    if (commercePlat === 'shopify' && commerceRef) {
        CheckoutService.getShopifyCartItems(commerceRef, variantIds, serviceIdParam)
            .then(data => {
                const enriched = data.products.map(product => ({
                    ...product,
                    quantity: variantQuantityMap[product.variantId] || 1
                }));
                setProducts(enriched);
                setSettings(data.settings);
            })
            .catch(() => setProducts([]));
        return;
    }

    const estoreId = storeIdParam || (commercePlat === 'estore' && commerceRef ? commerceRef : null);
    if (estoreId) {
        loadEstoreCart(estoreId);
    } else {
        setProducts([]);
    }
    }, []);

    useEffect(() => {
  const savedAddress = localStorage.getItem('checkout_address');
  if (savedAddress) {
    try {
      setAddress(JSON.parse(savedAddress));
    } catch (e) {
      console.error('Invalid address in localStorage');
    }
  }
}, []);
useEffect(() => {
    if (products && products.length > 0) {
  getCheckoutDetails();
  }
}, [products])
    console.log('products', products);
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === 'pincode') {
            // Only allow 6 digits, no spaces
            newValue = value.replace(/\D/g, '').slice(0, 6);
        }
        setAddress(prev => ({ ...prev, [name]: newValue }));
        setErrors(prev => ({ ...prev, [name]: '' }));

        // If state or pincode changes, call getOrderDetails (debounced)
        if ((name === 'state' || name === 'pincode')) {
            if (stateDebounceTimeout) clearTimeout(stateDebounceTimeout);
            const timeout = setTimeout(async () => {
                const qp = new URLSearchParams(window.location.search);
                const snapshot = { ...address, [name]: newValue };
                if (qp.get('commerce_platform') === 'shopify') {
                    await getCheckoutDetails(null, null, false, snapshot);
                    return;
                }
                let selectedPayment = null;
                let isPartialSelected = paymentOption === 'partialPayment';
                if (paymentOption === 'partialPayment') selectedPayment = 'PARTIAL';
                else if (paymentOption === 'whatsapp') selectedPayment = 'WHATSAPP';
                else if (paymentOption === 'offline') selectedPayment = 'COD';
                else if (paymentOption === 'online') selectedPayment = 'ONLINE';
                const payload = {
                    items: products.map((pro) => pro),
                    pin_code: snapshot.pincode,
                    state: snapshot.state,
                    country_code: snapshot.country,
                    is_partial: isPartialSelected,
                    coupon_code: couponCode,
                    selected_payment: selectedPayment,
                    store_id: getEffectiveEstoreStoreId(),
                };
                try {
                    const response = await CheckoutService.getOrderDetails(payload);
                    setCheckoutDetails(response);
                } catch {}
            }, 500);
            setStateDebounceTimeout(timeout);
        }
    };
    const scrollToFirstError = (errorFields) => {
        if (!errorFields.length) return;
        const field = errorFields[0];
        const el = document.querySelector(`[name="${field}"]`);
        if (el && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.focus();
        }
    };

    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^\d{10,}$/;
        const pincodeRegex = /^\d{6}$/; // Only 6 digits
        const requiredFields = ['firstname', 'email', 'mobile', 'address1', 'city', 'state', 'country', 'pincode'];

        requiredFields.forEach(field => {
            if (!address[field].trim()) {
                newErrors[field] = 'This field is required';
            }
        });

        if (address.email && !emailRegex.test(address.email)) {
            newErrors.email = 'Invalid email format';
        }

        if (address.mobile && !mobileRegex.test(address.mobile)) {
            newErrors.mobile = 'Invalid mobile number';
        }

        if (address.pincode && !pincodeRegex.test(address.pincode)) {
            newErrors.pincode = 'Invalid pincode';
        }

        return newErrors;
    };
    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    async function getCheckoutDetails(selectedPayment = null, isPartialSelected = null, remove, addressSnapshot = null) {
        const qp = new URLSearchParams(window.location.search);
        if (qp.get('commerce_platform') === 'woocommerce') {
            return;
        }
        const addr = addressSnapshot || address;
        if (qp.get('commerce_platform') === 'shopify') {
            let selectedPayments = selectedPayment;
            let partialSelected = isPartialSelected !== null ? isPartialSelected : paymentOption === 'partialPayment';
            if (paymentOption === 'partialPayment') selectedPayments = 'PARTIAL';
            else if (paymentOption === 'whatsapp') selectedPayments = 'WHATSAPP';
            else if (paymentOption === 'offline') selectedPayments = 'COD';
            else if (paymentOption === 'online') selectedPayments = 'ONLINE';
            else if (paymentOption === '') selectedPayments = 'COD';
            const payload = {
                items: products.map((pro) => pro),
                pin_code: addr.pincode,
                state: addr.state,
                country_code: addr.country,
                city: addr.city,
                address1: addr.address1,
                address2: addr.address2,
                mobile: addr.mobile,
                name: addr.firstname,
                firstname: addr.firstname,
                is_partial: partialSelected,
                coupon_code: remove ? null : couponCode.trim(),
                selected_payment: selectedPayments,
                store_id: getEffectiveEstoreStoreId(),
                commerce_platform: 'shopify',
                commerce_store_ref: qp.get('commerce_store_ref'),
            };
            try {
                const response = await CheckoutService.getOrderDetails(payload);
                setCheckoutDetails(response);
            } catch (error) {
                console.log('Checkout Details Error:', error);
                const subtotal = products.reduce((sum, pro) => {
                    const q = Number(pro.quantity || 1);
                    return sum + Number(pro.price || 0) * q;
                }, 0);
                setCheckoutDetails((prev) => ({
                    ...prev,
                    items: products,
                    subtotal,
                    total_amount: subtotal,
                    total: subtotal,
                    tax: 0,
                    all_tax: 0,
                    delivery_charge: 0,
                    coupon_amount: remove ? 0 : prev.coupon_amount,
                }));
            }
            return;
        }
        let selectedPayments = selectedPayment;
        let partialSelected = isPartialSelected !== null ? isPartialSelected : paymentOption === 'partialPayment';
        if (paymentOption === 'partialPayment') selectedPayments = 'PARTIAL';
        else if (paymentOption === 'whatsapp') selectedPayments = 'WHATSAPP';
        else if (paymentOption === 'offline') selectedPayments = 'COD';
        else if (paymentOption === 'online') selectedPayments = 'ONLINE';
        else if (paymentOption === '') selectedPayments = 'COD';
        const payload = {
            items: products.map((pro) => pro),
            pin_code: addr.pincode,
            state: addr.state,
            country_code: addr.country,
            is_partial: partialSelected,
            coupon_code: remove ? null : couponCode.trim(),
            selected_payment: selectedPayments,
            store_id: getEffectiveEstoreStoreId(),
        };
        try {
            const response = await CheckoutService.getOrderDetails(payload);
            setCheckoutDetails(response);
        } catch (error) {
            console.log('Checkout Details Error:', error);
            
        }
    }

    async function handlePaymentOptionChange(e) {
        setPaymentOption(e.target.value);
        let selectedPayment = null;
        let isPartialSelected = false;
        if (e.target.value === 'partialPayment') {
            selectedPayment = 'PARTIAL';
            setSelectedPayment('PARTIAL');
            isPartialSelected = true;
            setIsPartial(true);
        } else if (e.target.value === 'whatsapp') {
            selectedPayment='WHATSAPP';
            isPartialSelected=false;
        } else if (e.target.value === 'offline') {
            selectedPayment='COD';
            isPartialSelected=false;
        } else if (e.target.value === 'online') {
            selectedPayment='ONLINE';
            isPartialSelected=false;
        }
       await getCheckoutDetails(selectedPayment, isPartialSelected);
    };
    useEffect(() => {
    // getAllPlans();
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
    async function openRazorpay({ amount, razorpayOrderId, orderId, type, address }) {
  if (type === 'orkapay') {
    alert('Avoid using QR code. Payment may get failed');
  } 
  const url = '/payments/callback';
  return new Promise((resolve) => {
    // eslint-disable-next-line no-undef
    const instance = new Razorpay({
      "key": settings.razorpay_key_id,
      "amount": amount,
      // "currency": "INR",
      "name": settings.store_name,
      "order_id": razorpayOrderId,
      "handler": async (response) => {
        try {
          await request.post(url, {
            ...response,
            order_id: orderId
          });
        } catch (error) {
          console.log("handler error", error);
        }
        resolve();
      },
      "prefill": {
        "name": address.firstname,
        "email": address.email,
        "contact": address.mobile
      },
      "modal": {
        ondismiss: () => {
          window.alert('Payment Failed. Redirecting...');
          setTimeout(() => {
            redirect(window.location.search);
          }, 3000);
        }
      }
    });
    instance.open();
  });
  
}
    async function openVerticalRazorpay(orderPayload) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            const instance = new Razorpay({
                key: orderPayload.key_id,
                amount: orderPayload.amount,
                currency: orderPayload.currency,
                name: orderPayload.name || 'Orka Checkout',
                description: orderPayload.description || 'Booking payment',
                order_id: orderPayload.order_id,
                handler: async (response) => {
                    try {
                        await CheckoutService.confirmVerticalCheckoutPayment(
                            serviceId,
                            verticalCheckout.id,
                            response
                        );
                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                },
                prefill: orderPayload.prefill,
                modal: {
                    ondismiss: () => reject(new Error('Payment cancelled')),
                },
            });
            instance.open();
        });
    }

    const handleVerticalCheckout = async () => {
        const name = verticalCustomer.name.trim();
        const mobile = verticalCustomer.mobile.replace(/\D/g, '');
        if (!name || mobile.length < 8) {
            setMessage('Please enter customer name and valid mobile number.');
            return;
        }
        if (!verticalCheckout?.razorpay_key_id) {
            setMessage('Online checkout requires Razorpay payment-link credentials.');
            return;
        }
        setIsSubmitting(true);
        setMessage('');
        try {
            const paymentOrder = await CheckoutService.createVerticalCheckoutPayment(
                serviceId,
                verticalCheckout.id,
                {
                    name,
                    mobile,
                    address: verticalCustomer.address.trim(),
                }
            );
            await openVerticalRazorpay(paymentOrder);
            setVerticalSuccess(true);
            setSnackbar({
                open: true,
                message: 'Booking confirmed successfully.',
                severity: 'success',
            });
        } catch (error) {
            setMessage(error?.response?.data?.error?.message || error?.message || 'Payment failed.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderVerticalCheckout = () => {
        const summary = verticalCheckout?.summary || {};
        const isTicket = verticalCheckout?.vertical === 'ticket';
        const amount = Number(verticalCheckout?.amount || 0).toFixed(2);
        return (
            <div style={{
                maxWidth: 920,
                margin: '0 auto',
                padding: '40px 20px',
                fontFamily: 'Arial, sans-serif',
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: 18,
                    boxShadow: '0 18px 45px rgba(15,23,42,0.12)',
                    overflow: 'hidden',
                    border: '1px solid #e5e7eb',
                }}>
                    <div style={{
                        padding: '26px 30px',
                        background: 'linear-gradient(135deg, #0f766e, #1976d2)',
                        color: '#fff',
                    }}>
                        <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 6 }}>
                            Orka Checkout
                        </div>
                        <h2 style={{ margin: 0, fontSize: 28 }}>
                            {isTicket ? 'Confirm ticket booking' : 'Confirm appointment booking'}
                        </h2>
                        <p style={{ margin: '8px 0 0', opacity: 0.86 }}>
                            Review your booking details and complete payment securely.
                        </p>
                    </div>

                    {verticalLoading ? (
                        <div style={{ padding: 32 }}>Loading checkout...</div>
                    ) : verticalSuccess ? (
                        <div style={{ padding: 32, textAlign: 'center' }}>
                            <h3 style={{ color: '#15803d', fontSize: 24 }}>Booking confirmed</h3>
                            <p style={{ color: '#64748b' }}>
                                Your payment is successful. The business will receive your booking details.
                            </p>
                        </div>
                    ) : (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'minmax(0, 1.1fr) minmax(280px, 0.9fr)',
                            gap: 24,
                            padding: 30,
                        }}>
                            <div>
                                <h3 style={{ marginTop: 0, marginBottom: 16 }}>Customer details</h3>
                                <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
                                    Name *
                                </label>
                                <input
                                    value={verticalCustomer.name}
                                    onChange={(e) => setVerticalCustomer((prev) => ({
                                        ...prev,
                                        name: e.target.value,
                                    }))}
                                    placeholder="Customer name"
                                    style={{
                                        width: '100%',
                                        padding: 12,
                                        border: '1px solid #cbd5e1',
                                        borderRadius: 10,
                                        marginBottom: 14,
                                    }}
                                />
                                <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
                                    Mobile number *
                                </label>
                                <input
                                    value={verticalCustomer.mobile}
                                    onChange={(e) => setVerticalCustomer((prev) => ({
                                        ...prev,
                                        mobile: e.target.value,
                                    }))}
                                    placeholder="+91 98765 43210"
                                    style={{
                                        width: '100%',
                                        padding: 12,
                                        border: '1px solid #cbd5e1',
                                        borderRadius: 10,
                                        marginBottom: 14,
                                    }}
                                />
                                {!isTicket && (
                                    <>
                                        <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>
                                            Address or visit notes
                                        </label>
                                        <textarea
                                            value={verticalCustomer.address}
                                            onChange={(e) => setVerticalCustomer((prev) => ({
                                                ...prev,
                                                address: e.target.value,
                                            }))}
                                            placeholder="Optional, useful for home visits or location-specific appointments"
                                            rows={4}
                                            style={{
                                                width: '100%',
                                                padding: 12,
                                                border: '1px solid #cbd5e1',
                                                borderRadius: 10,
                                                resize: 'vertical',
                                            }}
                                        />
                                    </>
                                )}
                                {message && (
                                    <div style={{ color: '#b91c1c', marginTop: 12 }}>{message}</div>
                                )}
                                <button
                                    onClick={handleVerticalCheckout}
                                    disabled={isSubmitting || verticalCheckout?.status === 'paid'}
                                    style={{
                                        marginTop: 20,
                                        width: '100%',
                                        padding: '13px 18px',
                                        border: 'none',
                                        borderRadius: 12,
                                        background: '#1976d2',
                                        color: '#fff',
                                        fontSize: 16,
                                        fontWeight: 700,
                                        cursor: isSubmitting ? 'wait' : 'pointer',
                                    }}
                                >
                                    {isSubmitting ? 'Processing...' : `Pay ${verticalCheckout?.currency || 'INR'} ${amount}`}
                                </button>
                            </div>

                            <div style={{
                                background: '#f8fafc',
                                border: '1px solid #e2e8f0',
                                borderRadius: 16,
                                padding: 20,
                            }}>
                                <h3 style={{ marginTop: 0 }}>{summary.title || 'Booking'}</h3>
                                {summary.subtitle && (
                                    <p style={{ color: '#64748b', marginTop: -6 }}>{summary.subtitle}</p>
                                )}
                                {summary.starts_at && (
                                    <p style={{ color: '#334155' }}>
                                        {new Date(summary.starts_at).toLocaleString()}
                                    </p>
                                )}
                                {isTicket && Array.isArray(summary.lines) && summary.lines.map((line, index) => (
                                    <div key={`${line.tier_id}-${index}`} style={{
                                        padding: '10px 0',
                                        borderTop: '1px solid #e2e8f0',
                                    }}>
                                        <strong>{line.ticket_type}</strong>
                                        <div style={{ color: '#64748b' }}>Qty: {line.qty}</div>
                                        {line.seats?.length > 0 && (
                                            <div style={{ color: '#64748b' }}>
                                                Seats: {line.seats.join(', ')}
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {!isTicket && summary.ends_at && (
                                    <div style={{ color: '#64748b' }}>
                                        Ends: {new Date(summary.ends_at).toLocaleString()}
                                    </div>
                                )}
                                <div style={{
                                    marginTop: 18,
                                    paddingTop: 18,
                                    borderTop: '1px solid #cbd5e1',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    fontSize: 18,
                                    fontWeight: 800,
                                }}>
                                    <span>Total</span>
                                    <span>{verticalCheckout?.currency || 'INR'} {amount}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                >
                    <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
                </Snackbar>
            </div>
        );
    };

    if (verticalCheckout || verticalLoading) {
        return renderVerticalCheckout();
    }

    const handleCheckout = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            scrollToFirstError(Object.keys(validationErrors));
            return;
        }
        if (!paymentOption) {
            setMessage("Please select a payment option.");
            return;
        }
        const qpCheckout = new URLSearchParams(window.location.search);
        if (qpCheckout.get('commerce_platform') === 'woocommerce') {
            setMessage('WooCommerce web checkout is not connected yet; complete purchase in WhatsApp when available.');
            return;
        }
        setIsSubmitting(true);
        setMessage('');
        localStorage.setItem('checkout_address', JSON.stringify(address));
        const payload = {
            address,
            paymentOption,
            products: products.map(p => ({
                variantId: p.variantId,
                quantity: p.quantity,
                price: p.price,
            })),
            phoneNumber: phonenumber,
            storeId: getEffectiveEstoreStoreId(),
            commerce_platform: qpCheckout.get('commerce_platform'),
            commerce_store_ref: qpCheckout.get('commerce_store_ref'),
            orderFrom: 'wappgrow',
        };
        try {
           const response = await CheckoutService.createCart(payload);
           setOrder(response);
            if (response.payments && response.payments.length > 0) {
    const [payment] = response.payments;
    if (payment.type === TYPE.RAZORPAY || payment.type === TYPE.ORKAPAY) {
      await openRazorpay({
        orderId: response.id,
        amount: payment.amount * 100,
        razorpayOrderId: payment.payment_order_id,
        type: payment.type,
        address,
      });
    }
}
const checkoutPayload = {
    delivery_charge: checkoutDetails.delivery_charge,
    total_amount: checkoutDetails.total_amount,
    currency: checkoutDetails.currency,
    subtotal: checkoutDetails.subtotal,
    tax: checkoutDetails.tax,
    is_partial: checkoutDetails.is_partial,
    partial_amount: checkoutDetails.partial_amount,
    future_amount: checkoutDetails.future_amount,
    package_fee: checkoutDetails.package_fee,
    store_discount_amount: checkoutDetails.store_discount_amount,
    coupon_amount: checkoutDetails.coupon_amount,
    is_free_delivery: checkoutDetails.is_free_delivery,
    all_tax: checkoutDetails.all_tax,
    coupon: couponCode,
    }
        await CheckoutService.sendOrderMessage(products, phonenumber, serviceId, paymentOption, settings.whatsapp_upi_id, response, checkoutPayload);
        setProducts([]);
        setAddress({
            firstname: '',
            email: '',
            mobile: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            country: '',
            pincode: ''
        });
        setCouponCode("")
        setCheckoutDetails({
            items: [],
    delivery_charge: 0,
    total_amount: 0,
    currency: "₹",
    subtotal: 0,
    tax: 0,
    is_partial: false,
    partial_amount: 0,
    future_amount: 0,
    package_fee: 0,
    store_discount_amount: 0,
    coupon_amount: 0,
    is_free_delivery: true,
    all_tax: 0
        })
        setIsSubmitting(false);
        setSnackbar({
    open: true,
    message: "Order placed succesfully",
    severity: "success",
  });
        setOrderSuccess(true); // Show success popup
    } catch (err) {
            console.log('err', err);
            
            setMessage('An error occurred during checkout.');
        } finally {
            setIsSubmitting(false);
        }
    };
    async function handleApplyCoupon() {
        if (!couponCode.trim()) return;
        setIsApplyingCoupon(true);
        try {
            const response = await getCheckoutDetails();
            setSnackbar({ open: true, message: 'Coupon applied!', severity: 'success' });
        } catch (err) {
            setSnackbar({ open: true, message: 'Invalid coupon code', severity: 'error' });
        } finally {
            setIsApplyingCoupon(false);
        }
    };

    async function handleRemoveCoupon(params) {
        setCouponCode("");
        try {
            const response = await getCheckoutDetails(null, null, true);
            setSnackbar({ open: true, message: 'Coupon removed!', severity: 'success' });
        } catch (err) {
            setSnackbar({ open: true, message: 'Not removed', severity: 'error' });
        } finally {
            setIsApplyingCoupon(false);
        }
    }

    return (
        <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '40px 20px',
            fontFamily: 'Arial, sans-serif',
            position: 'relative'
        }}>
            {/* Success Popup Overlay */}
            {orderSuccess && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(255,255,255,0.95)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: 16,
                        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                        padding: '40px 32px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: 320
                    }}>
                        <div style={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            background: '#e6f9ea',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 24
                        }}>
                            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="24" cy="24" r="24" fill="#4CAF50"/>
                                <path d="M34 18L21.5 30.5L14 23" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div style={{ fontSize: 22, fontWeight: 700, color: '#222', marginBottom: 8, textAlign: 'center' }}>
                            Order created successfully
                        </div>
                        <div style={{ fontSize: 16, color: '#555', textAlign: 'center', marginBottom: 16 }}>
                            Thank you for your purchase!
                        </div>
                        <button
                            style={{
                                marginTop: 12,
                                padding: '10px 24px',
                                background: '#4CAF50',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontSize: 16,
                                cursor: 'pointer',
                                fontWeight: 600
                            }}
                            onClick={() => setOrderSuccess(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
            {/* Hide rest of UI if orderSuccess is true */}
            {!orderSuccess && (
            <>
            {/* Loading Spinner Overlay */}
            {isSubmitting && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(255,255,255,0.7)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        border: '6px solid #f3f3f3',
                        borderTop: '6px solid #0070f3',
                        borderRadius: '50%',
                        width: 48,
                        height: 48,
                        animation: 'spin 1s linear infinite'
                    }} />
                    <style>
                        {`
                        @keyframes spin {
                            0% { transform: rotate(0deg);}
                            100% { transform: rotate(360deg);}
                        }
                        `}
                    </style>
                </div>
            )}
            {/* Store Logo and Name */}
            {settings && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 20,
                    marginBottom: 18,
                    borderBottom: '1px solid #eee',
                    paddingBottom: 15
                }}>
                    {settings.store_logo && (
                        <img
                            src={settings.store_logo}
                            alt={settings.store_name || 'Store Logo'}
                            style={{
                                width: 64,
                                height: 64,
                                objectFit: 'contain',
                                borderRadius: 12,
                                background: '#fff',
                                border: '1px solid #eee',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        />
                    )}
                    <div style={{
                        fontSize: 20,
                        fontWeight: 700,
                        color: '#222',
                        letterSpacing: 1,
                        lineHeight: 1.1
                    }}>
                        {settings.store_name}
                    </div>
                </div>
            )}
            <h2 style={{ fontSize: 28, marginBottom: 14 }}>Checkout</h2>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32 }}>
                {/* Shipping Form */}
                <div style={{
                    flex: '1 1 60%',
                    background: '#fff',
                    padding: 24,
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    minWidth: 300
                }}>
                    <h3 style={{ marginBottom: 16 }}>Shipping Address</h3>
                    <div onKeyDown={handleFormKeyDown}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: 16
                        }}>
                            {[
                                { name: "firstname", placeholder: "First Name", required: true },
                                { name: "email", placeholder: "Email", type: "email", required: true },
                                { name: "mobile", placeholder: "Mobile", required: true },
                                { name: "address1", placeholder: "Address Line 1", required: true },
                                { name: "address2", placeholder: "Address Line 2", required: false },
                                { name: "city", placeholder: "City", required: true },
                                // { name: "state", placeholder: "State", required: true },
                                // country field will be handled separately
                                { name: "pincode", placeholder: "Pincode", required: true },
                            ].map(({ name, placeholder, type = "text", required }) => (
                                name !== "country" ? (
                                    <div key={name} style={{ display: 'flex', flexDirection: 'column' }}>
                                        <label style={{ marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                                            {placeholder}{required && '*'}
                                        </label>
                                        <input
                                            name={name}
                                            placeholder={placeholder}
                                            type={type}
                                            value={address[name]}
                                            onChange={handleChange}
                                            required={required}
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: 4,
                                                border: errors[name] ? '1px solid red' : '1px solid #ccc',
                                                fontSize: 14
                                            }}
                                        />
                                        {errors[name] && (
                                            <span style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                                                {errors[name]}
                                            </span>
                                        )}
                                    </div>
                                ) : null
                            ))}
                            {/* State dropdown for India */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                State*
            </label>
            <select
                name="state"
                value={address.state}
                onChange={handleChange}
                required
                style={{
                    padding: '8px 12px',
                    borderRadius: 4,
                    border: errors.state ? '1px solid red' : '1px solid #ccc',
                    fontSize: 14
                }}
            >
                <option value="">Select State</option>
                {INDIAN_STATES.map(state => (
                    <option key={state} value={state}>{state}</option>
                ))}
            </select>
            {errors.state && (
                <span style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                    {errors.state}
                </span>
            )}
        </div>
                            {/* Country dropdown */}
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ marginBottom: 4, fontWeight: 'bold', fontSize: 14 }}>
                                    Country*
                                </label>
                                <select
                                    name="country"
                                    value={address.country}
                                    onChange={handleChange}
                                    required
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: 4,
                                        border: errors.country ? '1px solid red' : '1px solid #ccc',
                                        fontSize: 14
                                    }}
                                >
                                    <option value="">Select Country</option>
                                    {COUNTRY_OPTIONS.map(opt => (
                                        <option key={opt.code} value={opt.code}>{opt.name}</option>
                                    ))}
                                </select>
                                {errors.country && (
                                    <span style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                                        {errors.country}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Order Summary */}
                <div style={{
                    flex: '1 1 35%',
                    background: '#fff',
                    padding: 24,
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    minWidth: 320,
                    maxWidth: 400,
                    height: 'fit-content',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    justifyContent: 'flex-start'
                }}>
                    <div>
                        <h3 style={{ marginBottom: 16, textAlign: 'left' }}>Order Summary</h3>
                        {products.length === 0 ? (
                            <p style={{ color: '#777', textAlign: 'center' }}>No products in cart.</p>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'separate',
                                    borderSpacing: 0,
                                    background: '#fafbfc'
                                }}>
                                    <thead>
                                        <tr style={{ textAlign: 'left', borderBottom: '2px solid #eee', background: '#f5f7fa' }}>
                                            <th style={{ padding: '8px', fontWeight: 600, fontSize: 14 }}>Image</th>
                                            <th style={{ padding: '8px', fontWeight: 600, fontSize: 14 }}>Name</th>
                                            <th style={{ padding: '8px', fontWeight: 600, fontSize: 14, textAlign: 'center' }}>Qty</th>
                                            <th style={{ padding: '8px', fontWeight: 600, fontSize: 14, textAlign: 'right' }}>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products.map((product, idx) => (
                                            <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                <td style={{ padding: '8px', verticalAlign: 'middle' }}>
                                                    <img
                                                        src={product.imageUrl}
                                                        alt={product.productName}
                                                        style={{
                                                            width: 48,
                                                            height: 48,
                                                            objectFit: 'cover',
                                                            borderRadius: 4,
                                                            border: '1px solid #ddd',
                                                            display: 'block',
                                                            margin: '0 auto'
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ padding: '8px', verticalAlign: 'middle', fontSize: 14 }}>{product.productName}</td>
                                                <td style={{ padding: '8px', verticalAlign: 'middle', textAlign: 'center', fontSize: 14 }}>{product.quantity}</td>
                                                <td style={{ padding: '8px', verticalAlign: 'middle', textAlign: 'right', fontSize: 14 }}>{product.price}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {/* Coupon code input */}
                        <div style={{ margin: '16px 0', display: 'flex', gap: 8 }}>
                <input
                    type="text"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    onChange={e => setCouponCode(e.target.value)}
                    disabled={Number(checkoutDetails.coupon_amount) > 0}
                    style={{ flex: 1, padding: '8px', borderRadius: 4, border: '1px solid #ccc', fontSize: 14 }}
                />
                {Number(checkoutDetails.coupon_amount) === 0 ? (
                    <button
                        type="button"
                        onClick={handleApplyCoupon}
                        disabled={isApplyingCoupon || !couponCode.trim()}
                        style={{ padding: '8px 16px', borderRadius: 4, background: '#0070f3', color: '#fff', border: 'none', cursor: isApplyingCoupon ? 'not-allowed' : 'pointer' }}
                    >
                        {isApplyingCoupon ? 'Applying...' : 'Apply'}
                    </button>
                ) : (
                    <button
                        type="button"
                        onClick={handleRemoveCoupon}
                        style={{ padding: '8px 16px', borderRadius: 4, background: '#f44336', color: '#fff', border: 'none', cursor: 'pointer' }}
                    >
                        Remove
                    </button>
                )}
            </div>
            {/* Payment Options */}
            {settings && (
  <div style={{ marginTop: 24 }}>
    <div style={{ fontWeight: 'bold', marginBottom: 16, fontSize: 16 }}>Payment Options</div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {settings.cod_enabled && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 14px',
            borderRadius: 8,
            border: paymentOption === "offline" ? '2px solid #4CAF50' : '1px solid #ccc',
            cursor: 'pointer',
            fontSize: 15,
            transition: 'all 0.2s',
          }}
        >
          <input
            type="radio"
            name="paymentOption"
            value="offline"
            checked={paymentOption === "offline"}
            onChange={handlePaymentOptionChange}
            style={{ marginRight: 10 }}
          />
          <div>
            <div style={{ fontWeight: 500 }}>COD</div>
            {settings.cod_text && <div style={{ fontSize: 13, color: '#666' }}>{settings.cod_text}</div>}
          </div>
        </label>
      )}

      {settings.razorpay_key_id && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 14px',
            borderRadius: 8,
            border: paymentOption === "online" ? '2px solid #4CAF50' : '1px solid #ccc',
            cursor: 'pointer',
            fontSize: 15,
            transition: 'all 0.2s',
          }}
        >
          <input
            type="radio"
            name="paymentOption"
            value="online"
            checked={paymentOption === "online"}
            onChange={handlePaymentOptionChange}
            style={{ marginRight: 10 }}
          />
          <div>
            <div style={{ fontWeight: 500 }}>Online</div>
            {settings.online_text && <div style={{ fontSize: 13, color: '#666' }}>{settings.online_text}</div>}
          </div>
        </label>
      )}

      {settings.whatsapp_checkout && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 14px',
            borderRadius: 8,
            border: paymentOption === "whatsapp" ? '2px solid #4CAF50' : '1px solid #ccc',
            cursor: 'pointer',
            fontSize: 15,
            transition: 'all 0.2s',
          }}
        >
          <input
            type="radio"
            name="paymentOption"
            value="whatsapp"
            checked={paymentOption === "whatsapp"}
            onChange={handlePaymentOptionChange}
            style={{ marginRight: 10 }}
          />
          <div>
            <div style={{ fontWeight: 500 }}>UPI</div>
            {settings.whatsapp_text && <div style={{ fontSize: 13, color: '#666' }}>{settings.whatsapp_text}</div>}
          </div>
        </label>
      )}

      {(settings.partial_amount || settings.partial_percent) && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 14px',
            borderRadius: 8,
            border: paymentOption === "partialPayment" ? '2px solid #4CAF50' : '1px solid #ccc',
            cursor: 'pointer',
            fontSize: 15,
            transition: 'all 0.2s',
          }}
        >
          <input
            type="radio"
            name="paymentOption"
            value="partialPayment"
            checked={paymentOption === "partialPayment"}
            onChange={handlePaymentOptionChange}
            style={{ marginRight: 10 }}
          />
          <div>
            <div style={{ fontWeight: 500 }}>Partial</div>
            {settings.partial_text && <div style={{ fontSize: 13, color: '#666' }}>{settings.partial_text}</div>}
          </div>
        </label>
      )}
    </div>
  </div>
)}
                        <div style={{ marginTop: 16, fontSize: 15 }}>
                {/* Delivery Charge */}
                {checkoutDetails && checkoutDetails.is_free_delivery && Number(checkoutDetails.delivery_charge) >= 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span>Delivery Charge</span>
                        <span>{checkoutDetails.currency} {checkoutDetails.delivery_charge}</span>
                    </div>
                )}
                {/* Tax and Tax Percentage */}
                {checkoutDetails && Number(checkoutDetails.tax) > 0 && Number(checkoutDetails.all_tax) > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                        <span>Tax ({checkoutDetails.all_tax ? checkoutDetails.all_tax + '%' : ''})</span>
                        <span>{checkoutDetails.currency} {checkoutDetails.tax}</span>
                    </div>
                )}
                {/* Coupon Amount */}
                {checkoutDetails && Number(checkoutDetails.coupon_amount) > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, color: 'green' }}>
                        <span>Coupon Discount</span>
                        <span>-{checkoutDetails.currency} {checkoutDetails.coupon_amount}</span>
                    </div>
                )}
                {/* Partial Payment Info */}
                {paymentOption === 'partialPayment' && checkoutDetails && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, color: '#0070f3' }}>
                            <span>Pay Now (Partial Amount)</span>
                            <span>{checkoutDetails.currency} {checkoutDetails.partial_amount}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, color: '#f39c12' }}>
                            <span>Pay Later (Future Amount)</span>
                            <span>{checkoutDetails.currency} {checkoutDetails.future_amount}</span>
                        </div>
                    </>
                )}
                {/* Grand Total */}
                <div style={{
                    marginTop: 16,
                    fontWeight: 'bold',
                    fontSize: 18,
                    textAlign: 'right',
                    borderTop: '1px solid #eee',
                    paddingTop: 16
                }}>
                    Grand Total: {checkoutDetails.currency} {checkoutDetails.total_amount}
                </div>
            </div>
                    </div>
                    {/* Checkout Button */}
                    <div style={{ marginTop: 32 }}>
                        <button
                            type="button"
                            onClick={() => { handleCheckout() }}
                            disabled={isSubmitting}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: 16,
                                backgroundColor: '#0070f3',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 4,
                                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                opacity: isSubmitting ? 0.6 : 1
                            }}
                        >
                            {isSubmitting ? 'Processing...' : 'Place Order'}
                        </button>
                        {message && (
                            <div style={{ marginTop: 12, color: message.includes('successfully') ? 'green' : 'red', textAlign: 'center' }}>
                                {message}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                  >
                    <Alert
                      onClose={() => setSnackbar({ ...snackbar, open: false })}
                      severity={snackbar.severity}
                      sx={{ width: "100%" }}
                    >
                      {snackbar.message}
                    </Alert>
                  </Snackbar>
                  </>
             )}   
        </div>
    );
}


export default CheckoutView;
